import { inherits as _inherits, createClass as _createClass, extends as _extends, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from './Controls/FormControl.js';
import FormGroup from 'react-bootstrap/FormGroup';
import FormLabel from 'react-bootstrap/FormLabel';
import { UnderscoresToTitleCase } from '../../utils/StringUtil.js';
import { GetValidationMessage, GetValidationPattern } from '../../utils/ValidationUtil.js';
import { i18n } from '../../i18n/translate.js';
import kebabCase from 'lodash/kebabCase.js';
import { InfoTooltip } from '../InfoTooltip/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var FormField = /*#__PURE__*/function (_React$Component) {
  function FormField(props) {
    var _this;

    _classCallCheck(this, FormField);

    _this = _callSuper(this, FormField, [props]);

    _defineProperty(_this, "setError", function (error, message) {
      if (_this.state.hasError !== error) {
        _this.setState({
          hasError: error
        }, function () {
          if (_this.props.validationType && _this.state.hasError) {
            _this.setState({
              validationError: GetValidationMessage(_this.props.validationType)
            });
          } else if (_this.state.hasError && message) {
            _this.setState({
              validationError: message
            });
          } else {
            _this.setState({
              validationError: false
            });
          }
        });
      } else if (_this.state.validationError !== message && !_this.props.validationType) {
        _this.setState({
          validationError: message
        });
      }
    });

    _defineProperty(_this, "renderField", function () {
      var pattern = _this.props.validationType ? GetValidationPattern(_this.props.validationType) : _this.props.pattern;

      if (_this.props.children) {
        return /*#__PURE__*/React.cloneElement(React.Children.only(_this.props.children), {
          dataValue: _this.props.dataValue,
          setError: _this.setError,
          required: _this.props.required,
          name: _this.props.name,
          isFloatOutside: _this.props.isFloatOutside,
          onValueChange: _this.props.onValueChange,
          valueChangeDelay: _this.props.valueChangeDelay,
          ref: function ref(control) {
            return _this.control = control;
          },
          onBlur: _this.props.onBlur,
          onFocus: _this.props.onFocus,
          scrollContainerId: _this.props.scrollContainerId,
          disabled: _this.props.disabled,
          'aria-describedby': "".concat(_this.props.name, "-hint")
        });
      } else {
        return /*#__PURE__*/React.createElement(FormControl, _extends({}, _this.props, {
          pattern: pattern !== null && pattern !== void 0 ? pattern : _this.props.pattern,
          ref: function ref(control) {
            return _this.control = control;
          },
          setError: _this.setError,
          className: _this.props.inputClassName,
          "aria-describedby": "".concat(_this.props.name, "-hint")
        }));
      }
    });

    _this.state = {
      hasError: false,
      validationError: false
    };
    return _this;
  }

  _inherits(FormField, _React$Component);

  return _createClass(FormField, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$control, _this$control2;

      if (this.props.runValidation && this.control && this.control.isValid) {
        this.control.checkError();
      }

      if ((_this$control = this.control) !== null && _this$control !== void 0 && (_this$control = _this$control.props) !== null && _this$control !== void 0 && _this$control.required && (_this$control2 = this.control) !== null && _this$control2 !== void 0 && (_this$control2 = _this$control2.props) !== null && _this$control2 !== void 0 && _this$control2.files) {
        this.control.activeFiles().length > 0 ? this.setError(false) : this.setError(true, i18n.t('This field is required'));
      }
    }
  }, {
    key: "renderLowerText",
    value: function renderLowerText() {
      var _this$props = this.props,
          hintText = _this$props.hintText,
          hintLink = _this$props.hintLink,
          errorMessage = _this$props.errorMessage;
      var validationError = this.state.validationError;
      var lowerText = hintText || '';
      var lowerTextStyle = 'input-hint';
      var error = errorMessage || validationError;

      if (error) {
        lowerText = error;
        lowerTextStyle = 'input-error';
      }

      if (!lowerText) return null;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: lowerTextStyle,
        "data-action": lowerTextStyle,
        id: "".concat(this.props.name, "-hint")
      }, typeof lowerText === 'string' ? UnderscoresToTitleCase(lowerText) : lowerText), hintLink && !validationError ? hintLink : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          activeLanguage = _this$props2.activeLanguage,
          propClassName = _this$props2.className,
          data = _this$props2.data,
          dataObjectId = _this$props2.dataObjectId,
          dataObjectType = _this$props2.dataObjectType,
          dataObjectAttribute = _this$props2.dataObjectAttribute,
          dataObjectAction = _this$props2.dataObjectAction,
          errorMessage = _this$props2.errorMessage,
          isFloatOutside = _this$props2.isFloatOutside,
          languages = _this$props2.languages,
          multilingual = _this$props2.multilingual,
          name = _this$props2.name,
          required = _this$props2.required,
          srHelpText = _this$props2.srHelpText;
      var currentLanguage = (languages === null || languages === void 0 ? void 0 : languages.filter(function (language) {
        return Object.keys(language)[0] === activeLanguage;
      })) || '';

      var className = _formatClassName([propClassName, {
        'has-error is-invalid': this.state.hasError || errorMessage
      }, {
        'required-form-control': required
      }, {
        'fg-floatoutside': isFloatOutside
      }]);

      var caption = multilingual ? "".concat(this.props.caption, " (").concat(currentLanguage[0][activeLanguage], ")") : this.props.caption;
      var dataId = dataObjectId || data && data.id && data.id;
      var dataType = dataObjectType || data && data.type && data.type;
      var dataAttribute = dataObjectAttribute || data && data.name && data.name;
      React.Children.forEach(this.props.children, function (child) {
        var _child$type$propTypes;

        if ((_child$type$propTypes = child.type.propTypes) !== null && _child$type$propTypes !== void 0 && _child$type$propTypes.controlLabelText && caption) {
          console.warn("\n          This component has its own caption capability (controlLabeltext).\n          Please move the caption from the FromField wrapper to the wrapped\n          component.\n        ");
        }
      });
      return /*#__PURE__*/React.createElement(FormGroup, {
        controlId: name,
        className: className,
        "data-field-name": name,
        "data-object-id": dataId,
        "data-object-type": dataType,
        "data-object-attribute": dataAttribute || "".concat(kebabCase(name), "-form-field"),
        "data-object-action": dataObjectAction,
        key: name
      }, /*#__PURE__*/React.createElement("div", {
        className: this.props.wrapperClassName
      }, caption && /*#__PURE__*/React.createElement(FormLabel, {
        className: this.props.labelClassName,
        "aria-hidden": this.props.hideControlLabelAria,
        id: "".concat(this.props.name, "-label")
      }, this.props.searchField || '', " ", caption, " ", srHelpText && /*#__PURE__*/React.createElement("span", {
        className: "sr-only"
      }, srHelpText)), this.renderField(), this.props.tooltip ? /*#__PURE__*/React.createElement(InfoTooltip, _extends({}, this.props, {
        label: i18n.t('More information about %s', {
          postProcess: 'sprintf',
          sprintf: [this.props.caption]
        })
      })) : null), this.renderLowerText());
    }
  }]);
}(React.Component);

_defineProperty(FormField, "propTypes", {
  activeLanguage: PropTypes.string,
  caption: PropTypes.string,
  children: PropTypes.element,
  className: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string
  }),
  dataObjectAction: PropTypes.string,
  dataObjectAttribute: PropTypes.string,
  dataObjectId: PropTypes.string,
  dataObjectType: PropTypes.string,
  dataValue: PropTypes.any,
  disabled: PropTypes.bool,
  errorColor: PropTypes.string,
  errorMessage: PropTypes.string,
  hintLink: PropTypes.node,
  hintText: PropTypes.string,
  hideControlLabelAria: PropTypes.bool,
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  isFloatOutside: PropTypes.bool,
  languages: PropTypes.arrayOf(PropTypes.object),
  multilingual: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onValueChange: PropTypes.func,
  pattern: PropTypes.string,
  required: PropTypes.bool,
  runValidation: PropTypes.bool,
  scrollContainerId: PropTypes.string,
  searchField: PropTypes.element,
  srHelpText: PropTypes.string,
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.string,
  validationType: PropTypes.string,
  valueChangeDelay: PropTypes.number,
  wrapperClassName: PropTypes.string
});

_defineProperty(FormField, "defaultProps", {
  errorColor: '#e71c0d',
  tooltipPosition: 'left'
});

FormField.displayName = "FormField";
export { FormField };